import { useMemo, useState } from "react";
import { Link, useParams, useSearchParams } from "react-router-dom";
import Box from "@mui/material/Box";
import Paper from "@mui/material/Paper";
import Typography from "@mui/material/Typography";
import BatchTable from "../components/ETax/Batch/BatchTable";
import {
  buildDateRangeSearch,
  resolveDateRangeParams,
} from "../components/ETax/dateRangeParams";
import { getEtaxBreadcrumbLabel } from "../components/ETax/etaxTitle";

export default function ETaxBatchDetailsPage() {
  const { batchId } = useParams<{ batchId: string }>();
  const [searchParams] = useSearchParams();
  const dateFromParam = searchParams.get("date_from");
  const dateToParam = searchParams.get("date_to");
  // Memoised so the parsed Dayjs values stay referentially stable across renders; an
  // inverted pair from a hand-edited link is swapped.
  const { from: startDate, to: endDate } = useMemo(
    () => resolveDateRangeParams(dateFromParam, dateToParam),
    [dateFromParam, dateToParam],
  );

  const dateSearch = buildDateRangeSearch(startDate, endDate);

  const [triggerFetch, setTriggerFetch] = useState<number>(0);

  return (
    <Box sx={{ padding: "8px 0" }}>
      <Box sx={{ display: "flex", alignItems: "center", mb: 2 }}>
        {/* Both crumbs carry the range, so going back lands on the figures this batch was
            opened from rather than the default month. */}
        <Link
          to={`/e-tax${dateSearch}`}
          style={{ textDecoration: "none", color: "inherit" }}
        >
          <Typography variant="body1" sx={{ fontWeight: 500 }}>
            {getEtaxBreadcrumbLabel()}
          </Typography>
        </Link>
        <Typography variant="body1" sx={{ mx: 1 }}>
          /
        </Typography>
        <Link
          to={`/e-tax/history${dateSearch}`}
          style={{ textDecoration: "none", color: "inherit" }}
        >
          <Typography variant="body1" sx={{ fontWeight: 500 }}>
            ประวัติการส่ง
          </Typography>
        </Link>
        <Typography variant="body1" sx={{ mx: 1 }}>
          /
        </Typography>
        <Typography variant="body1" color="primary">
          รายละเอียด
        </Typography>
      </Box>

      <Paper>
        <BatchTable
          selectedBatchId={batchId ?? ""}
          triggerFetch={triggerFetch}
          setTriggerFetch={setTriggerFetch}
          dateFrom={startDate}
          dateTo={endDate}
        />
      </Paper>
    </Box>
  );
}
